import CustomButton from "__utilities/components/CustomButton";
import Popup from "__utilities/components/Popup";

export default function InfoPopup({ text, subtext, onClose }) {
  return (
    <Popup>
      <div className="content-infoIcon w-[24px] h-[24px] mb-[10px]" />
      <div className="text-primaryBlue font-latoBold mb-[10px] text-center">
        {text}
      </div>
      {subtext && (
        <div className="text-primaryBlue font-latoLight font-standardSmall m-[30px] mt-[20px] text-justify">
          {subtext}
        </div>
      )}
      <CustomButton text={"Luk"} onClick={onClose} styles="w-[60%] py-[8px]" />
    </Popup>
  );
}
